import { RemoteGetAllStudentsSelectOptions } from 'data/usecases';
import { GetAllStudentsSelectOptionsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlStudentsSelectOptions } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllStudentsSelectOptions =
  (): GetAllStudentsSelectOptionsUseCaseInterface =>
    new RemoteGetAllStudentsSelectOptions(
      makeApiUrlStudentsSelectOptions(),
      makeAxiosHttpClient(),
    );
